﻿import React, { Fragment, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { ProductCategory, Supplier, ProductBadge } from "./Interfaces";
import { slugify } from "../../helpers/Formatters";
import { Feather } from "../../helpers/Feather";
import { Popover } from 'react-tiny-popover'
import { SimplePopover } from "../../components/SimplePopover";

export function SidebarBadgeFilters(props: { badges: ProductBadge[]; filters: number[]; updateFilters: (badgeIds: number[]) => void }) {
    const [expanded, setExpanded] = useState(false);
    const [showTooltip, setShowTooltip] = useState<number>(0);
    const [tooltipClearByClick, setTooltipClearByClick] = useState(false);

    return props.badges.length > 0 ? (<div className="mb-2">
        <h3 onClick={() => setExpanded(!expanded)} className="cursor-pointer text-nowrap">Refine by Food Hero Filters <Feather icon={expanded ? 'chevron-up' : 'chevron-down'} size={24} /></h3>
        {expanded ? <div className="pl-3">
            {props.badges.map(x => (<div className="custom-control custom-checkbox">
                <input className="custom-control-input" type="checkbox" id={`badge-hero-${x.id}`} value={x.id} checked={props.filters.includes(x.id)} onChange={(e) => e.target.checked ? props.updateFilters([...props.filters, x.id]) : props.updateFilters(props.filters.filter(y => y !== x.id))} />
                <label className="custom-control-label cursor-pointer" htmlFor={`badge-hero-${x.id}`}>
                    <Popover isOpen={showTooltip === x.id} positions={['top', 'right', 'bottom', 'left']} content={<SimplePopover markup={`<h5>${x.name}</h5>${x.description}`} className="p-2" />} padding={6} boundaryInset={6} onClickOutside={() => { setShowTooltip(0); }}>
                        <span className="mr-1 cursor-default align-top" style={{ lineHeight: '1.25rem' }} onMouseOver={() => { setShowTooltip(x.id); }} onTouchStart={() => setTooltipClearByClick(true)} onMouseOut={() => { if (!tooltipClearByClick) { setShowTooltip(0); } }}><Feather icon="info" size={18} /></span>
                    </Popover>
                    {x.name}
                </label>
            </div>))}
        </div> : null}
    </div>) : null;
}

export function SidebarFilterNav(props: { categories: ProductCategory[]; suppliers: Supplier[] }) {
    return (<div>        
        <h3>Shop by Category</h3>
        <ul className="list-unstyled">
            <NavLink className="cat-link" to={`/Shop`} exact activeClassName="selected">New &amp; Featured</NavLink>
            {props.categories.map(x => (<Fragment>
                <li>
                    <strong>
                        <NavLink className="cat-link" to={`/Shop/Category/${slugify(x.name)}`} exact activeClassName="selected">{x.name}</NavLink>
                    </strong>
                </li>
                {x.subcategories.length > 1 ? (<ul className="list-unstyled">
                    {x.subcategories.map(y => (
                        <li>
                            <NavLink className="subcat-link" to={`/Shop/Category/${slugify(x.name)}/${slugify(y.name)}`} activeClassName="selected">{y.name}</NavLink>
                        </li>
                    ))}
                </ul>) : null}
            </Fragment>))}
        </ul>

        <h3>Shop by Supplier</h3>
        <ul className="list-unstyled">
            {props.suppliers.map(x => (
                <li>
                    <NavLink className="sup-link" to={`/Shop/Supplier/${x.slug}`} activeClassName="selected">{x.name}</NavLink>
                </li>
            ))}
        </ul>
    </div>);
}

export function CollapseFilterNav(props: { categories: ProductCategory[]; suppliers: Supplier[] }) {
    const [showingCategories, setShowingCategories] = useState(false);
    const [showingSuppliers, setShowingSuppliers] = useState(false);

    function onNavClick() {
        document.getElementById('mobile-nav-toggler').click();
    }

    return (
        <ul className="navbar-nav d-block d-md-none">
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" onClick={() => { setShowingCategories(!showingCategories); return false; }} >
                    Categories
                </a>                
                <div className={showingCategories ? "dropdown-menu show" : "dropdown-menu"}>
                    <NavLink className="dropdown-item dropdown-item-heading" to={`/Shop`} exact activeClassName="active" onClick={onNavClick}>Featured</NavLink>
                    {props.categories.map(x => (<Fragment>
                        <NavLink className="dropdown-item dropdown-item-heading" to={`/Shop/Category/${slugify(x.name)}`} exact activeClassName="active" onClick={onNavClick}>{x.name}</NavLink>
                        {x.subcategories.length > 1 ? x.subcategories.map(y => (<NavLink className="dropdown-item" to={`/Shop/Category/${slugify(x.name)}/${slugify(y.name)}`} activeClassName="active" onClick={onNavClick}>{y.name}</NavLink>)) : null}
                    </Fragment>))}
                </div>
            </li>
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" onClick={() => { setShowingSuppliers(!showingSuppliers); return false; }} >
                    Suppliers
                </a>
                <div className={showingSuppliers ? "dropdown-menu show" : "dropdown-menu"}>
                    {props.suppliers.map(x => (
                        <NavLink className="dropdown-item" to={`/Shop/Supplier/${x.slug}`} activeClassName="active" onClick={onNavClick}>{x.name}</NavLink>
                    ))}
                </div>
            </li>
        </ul>
    );
}

export function MobileBadgeFilters(props: { badges: ProductBadge[]; filters: number[]; updateFilters: (badgeIds: number[]) => void }) {
    return props.badges.length > 0 ? (
        <select className="custom-select custom-select-sm mb-3" multiple onChange={(e) => {
            var options = e.target.options;
            var selected = [];
            for (var i = 0, l = options.length; i < l; i++) {
                if (options[i].selected && options[i].value !== '') {
                    selected.push(parseInt(options[i].value, 10));
                }
            }
            props.updateFilters(selected);
        }}>
            <option value='' disabled selected>Refine by Food Hero Filters</option>
            {props.badges.map(x => <option value={x.id}>{ x.name }</option>)}
        </select>
    ) : null;
}

export function MobileTopNav(props: { categories: ProductCategory[]; suppliers: Supplier[]; }) {
    const history = useHistory();

    return (
        <select className="custom-select custom-select-sm" value='' onChange={(e) => e.target.value !== '' ? history.push(e.target.value) : null}>
            <option value=''>Categories & Suppliers</option>
            <optgroup label="Categories">
                <option value={`/Shop`}>New &amp; Featured</option>
                {props.categories.map(x => (<Fragment>
                    <option value={`/Shop/Category/${slugify(x.name)}`}>{x.name}</option>
                    {x.subcategories.length > 1 ? x.subcategories.map(y => (<option value={`/Shop/Category/${slugify(x.name)}/${slugify(y.name)}`}>&nbsp;&nbsp;{y.name}</option>)) : null}
                </Fragment>))}
            </optgroup>
            <optgroup label="Suppliers">
                {props.suppliers.map(x => (
                    <option value={`/Shop/Supplier/${x.slug}`}>{x.name}</option>
                ))}
            </optgroup>
    </select>);
}